import { render, staticRenderFns } from "./ExpandableItemFondeo.vue?vue&type=template&id=527c5caf&scoped=true&"
import script from "./ExpandableItemFondeo.vue?vue&type=script&lang=js&"
export * from "./ExpandableItemFondeo.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableItemFondeo.vue?vue&type=style&index=0&id=527c5caf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c5caf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
